module.exports = __webpack_public_path__ + "static/logo_free_your_inbox_nb-280fc1a81aa463d70dda51a332d86003.svg";